export default __webpack_public_path__ + "static/SR USA - Application Guide for Powder Caramel Colors-03f5dd46810a8a4fb5733f8dbc87cd20.pdf";